import { CmsCategoryCodeEnum } from '~/src/models/enums/cms.enum';
import { getArticlesDictionary } from '~/src/repositories/cms/shared/cms.base.repository';
import { getMappedDocumentationFilesData } from '~/src/repositories/cms/shared/utils/cms.utils';

export const getAgentsApiDocumentationData = async (
    isSSR: boolean,
    categoryCode: CmsCategoryCodeEnum,
    articleSefUrl?: string,
) => {
    const data = await getArticlesDictionary({
        isSSR,
        categoryCode,
        articleSefUrl,
    });

    if ('cmsFailed' in data) {
        return { cmsFailed: true };
    }

    return getMappedDocumentationFilesData(data);
};
